import { TeamsContext } from "./../context/TeamsContext";
import React from "react";

export default function useTeams() {
  return React.useContext(TeamsContext);
}
